import type { FC } from 'react';

import dynamic from 'next/dynamic';

import { TabPanel } from '@mui/lab';

import Box from '@mui/material/Box';

import Tab from '@mui/material/Tab';

import { t } from '@/utils/lang';
import BusinessTripFormInfo from '@/views/apps/phieu-cong-tac/view/BusinessTripFormInfo';
import type { EntityComponentProps } from '../../types/EntityComponent.types';
import TabContainer from './Tabs/Common/TabContainer';

const Task = dynamic(() => import('./Tabs/BusinessTripForm/Task'), {
    ssr: false,
});

const BusinessTripFormEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <BusinessTripFormInfo data={data} />
            <TabContainer
                defaultTab='task'
                tabPanels={
                    <>
                        <TabPanel value='task'>
                            <Task businessTripFormId={data.id} />
                        </TabPanel>
                    </>
                }
            >
                <Tab label={t('Task')} value='task' />
            </TabContainer>
        </Box>
    );
};

export default BusinessTripFormEntityContent;
